import React, {Component} from 'react'

import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import {Form} from 'react-form'
import UserForm from './UserForm'
import {Grid} from 'react-bootstrap'
import showToastr from '../../utils/showToastr'
import ErrorHandler from '../../utils/ErrorHandler'
import validateUser from '../../utils/validateUser'
import setAuthorizationToken from '../../utils/setAuthorizationToken'

export const defaultUser = {
  username: '',
  password: '',
  email: '',
  mobile: '',
  terms: false
}

class SignupScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentUser: defaultUser,
      message: {type: '', context: ''},
      isLoading: false
    }
    this.submit = this.submit.bind(this)
  }

  submit (values) {
    this.setState({isLoading: true})
    Actions.signup(values).then((res) => {
      this.setState({isLoading: false})
      setAuthorizationToken(res.data.token)
      Actions.userInfo().then((user) => {
        let auth = {token: res.data.token, user: {id: user.id, username: user.username, avatar: null}}
        Actions.logged_in(auth)
        showToastr('success', 'ثبت نام', res.data.messages[0])
        browserHistory.push('/user/dashboard')
      })
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.signupForm)
      eh.showToastrIn('ثبت نام')
    })
  }

  render () {
    const { currentUser, message, isLoading } = this.state
    return (
      <Grid fluid id="signup">
        {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
        <Form
          ref="signupForm"
          values={currentUser}
          disable={isLoading}
          validate={validateUser}
          onSubmit={this.submit}
        >
          {UserForm}
        </Form>
      </Grid>
    )
  }
}

export default SignupScreen



// WEBPACK FOOTER //
// ./src/components/Signup/SignupScreen.js